import * as React from 'react';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import {
  BoldTableCell,
  StyledTableHead,
  StyledTable,
  BoldTableCellHeading,
  CellTextLink,
} from './NoodleTable.styles';
import type { NoodleTableProps } from './NoodleTable.types';

const NoodleTable = ({
  className,
  ...restProps
}: NoodleTableProps): React.ReactElement<any> | null => (
  <StyledTable className={className} {...(restProps as any)} />
);

NoodleTable.Head = (props: Record<string, any>) => <StyledTableHead {...props} />;

NoodleTable.BoldCell = (props: Record<string, any>) => <BoldTableCell {...props} />;

NoodleTable.Cell = (props: Record<string, any>) => <TableCell {...props} />;

NoodleTable.CellHeading = (props: Record<string, any>) => <BoldTableCellHeading {...props} />;

NoodleTable.CellTextLink = (props: Record<string, any>) => <CellTextLink {...props} />;

NoodleTable.Row = (props: Record<string, any>) => <TableRow {...props} />;

NoodleTable.Body = (props: Record<string, any>) => <TableBody {...props} />;

export default NoodleTable;
